const state = {
	savedProjectIds: [],
	totalSavedProjects: 0,
	savedProjects: [],
	filters: {},
	selectedFilters: [],
	selectedSubFilters: [],
	areFiltersForSavedProjectsLoaded: false,
	showFiltersForSavedProjects: true,
	mobileDisplayPixels: 600,
	text: ''
};

const getters = {
	getSavedProjectIds: (state) => state.savedProjectIds,
	getSavedProjects: (state) => state.savedProjects ? state.savedProjects : [],
	getSelectedFiltersForSavedProjects: (state) => state.selectedFilters,
	getSelectedSubFiltersForSavedProjects: (state) => state.selectedSubFilters,
	getFilterOptionsByTypeForSavedProjects: (state) => (filterName) => state.filters[filterName],
	getAreFiltersForSavedProjectsLoaded: (state) => state.areFiltersForSavedProjectsLoaded,
	getShowFiltersForSavedProjects: (state) => state.showFiltersForSavedProjects,
	getMobileDisplayPixelsForSavedProjects: (state) => state.mobileDisplayPixels,
	getTotalSavedProjects: (state) => state.totalSavedProjects,
	getTextForSavedProjects: (state) => state.text,
};

const actions = {
	setUserSavedProjects: ({commit}, projects) => {
		commit("setUserSavedProjectsMutations", projects);
	},
	addUserSavedProjectsOnScroll: ({commit}, payload) => {
		commit("addUserSavedProjectsOnScrollMutations", payload);
	},
	removeSavedProjectFromStore({commit}, projectId) {
		commit("removeSavedProjectFromStoreMutation", projectId);
	},
	reduceTotalProjectsWithOne: ({commit}) => {
		commit("reduceTotalProjectsWithOne");
	},
	addToSavedProjectIds({commit}, projectIds) {
		commit("addToSavedProjectIdsMutation", projectIds);
	},
	removeSelectedFilterForSavedProjects({commit}, filter) {
		commit("removeSelectedFilterForSavedProjectsMutation", filter);
	},
	removeSelectedSubFilterForSavedProjects({commit}, payload) {
		commit("removeSelectedSubFilterForSavedProjectsMutation", payload);
	},
	addSelectedFilterForSavedProjects({commit}, filter) {
		commit("addSelectedFilterForSavedProjectsMutation", filter);
	},
	addSelectedSubFilterForSavedProjects({commit}, payload) {
		commit("addSelectedSubFilterForSavedProjectsMutation", payload);
	},
	resetSelectedFiltersForSavedProjects({commit}) {
		commit("resetSelectedFiltersForSavedProjectsMutation");
	},
	setFiltersForSavedProjects({commit}, filters) {
		commit("setFiltersForSavedProjectsMutation", filters);
	},
	changeShowFiltersForSavedProjects({commit}, payload) {
		commit("changeShowFiltersForSavedProjectsMutation", payload);
	},
	changeTextForSavedProjects({commit}, payload) {
		commit("changeTextForSavedProjectsMutation", payload);
	}
}

const mutations = {
	addToSavedProjectIdsMutation: (state, projectIds) => {
		state.savedProjectIds = projectIds;
	},
	reduceTotalProjectsWithOne: (state) => {
		if (state.totalSavedProjects > 0) {
			state.totalSavedProjects -= 1;
		}
	},
	removeSavedProjectFromStoreMutation: (state, projectId) => {
		if (state.savedProjects) {
			state.savedProjects = state.savedProjects.filter(project => project.id !== projectId);
		}
	},
	setUserSavedProjectsMutations: (state, payload) => {
		state.totalSavedProjects = payload.total;
		state.savedProjects = payload.projects;
	},
	addUserSavedProjectsOnScrollMutations: (state, payload) => {
		state.totalSavedProjects = payload.total;
		state.savedProjects.push(...payload.projects)
	},
	removeSelectedFilterForSavedProjectsMutation: (state, filter) => {
		const indexToRemove = state.selectedFilters
			.findIndex(selectedFilter => selectedFilter.id === filter.id && selectedFilter.filterType === filter.filterType);

		if (indexToRemove !== -1) {
			state.selectedFilters.splice(indexToRemove, 1);
		}
	},
	addSelectedFilterForSavedProjectsMutation: (state, filter) => {
		const foundFilter = state.selectedFilters
			.find(selectedFilter => selectedFilter.filterType === filter.filterType && selectedFilter.id === filter.id);

		if (!foundFilter) {
			state.selectedFilters.push(filter);
		}
	},
	setFiltersForSavedProjectsMutation: (state, filters) => {
		filters
			.filter(filter => {
				const type = filter.data[0].filterType;
				return type === "techPractices" || type === "industries" || type === "serviceLines"
		})
			.forEach(filter => {
			const filterType = filter.data[0].filterType;
			const value = filter.data;

			state.filters[`${filterType}`] = value;
		});
		state.areFiltersForSavedProjectsLoaded = true;
	},
	changeShowFiltersForSavedProjectsMutation: (state, payload) => {
		state.showFiltersForSavedProjects = payload
	},
	resetSelectedFiltersForSavedProjectsMutation: (state) => {
		state.selectedFilters = [];
	},
	removeSelectedSubFilterForSavedProjectsMutation: (state, subFilter) => {
		function capitalize(input) {
			const capitalizedString = input[0].toUpperCase() + input.slice(1);

			return input.startsWith("sub") ? input : "sub" + capitalizedString;
		}

		const indexToRemove = state.selectedSubFilters
			.findIndex(subOption => subOption.id === subFilter.id && subOption.filterType === capitalize(subFilter.filterType));

		if (indexToRemove !== -1) {
			state.selectedSubFilters.splice(indexToRemove, 1);
		}
	},
	addSelectedSubFilterForSavedProjectsMutation: (state, payload) => {
		const foundSubFilter = state.selectedSubFilters.filter(subFilter =>
			subFilter.id === payload.id
			&& subFilter.mainFilterId === payload.mainFilterId
			&& subFilter.mainFilterType === payload.mainFilterType);

		function capitalize(input) {
			const capitalizedString = input[0].toUpperCase() + input.slice(1);

			return input.startsWith("sub") ? input : "sub" + capitalizedString;
		}

		if (foundSubFilter.length === 0) {
			state.selectedSubFilters.push({...payload, filterType: capitalize(payload.filterType), isSubOption: true});
		}
	},
	changeTextForSavedProjectsMutation: (state, payload) => {
		state.text = payload
	}
}

export default {state, getters, actions, mutations};
